// This function retrieves the AI team settings from local storage.
/**
 * @property {Object[]} teams - The teams object containing AI settings.
 * @property {string} targetTeamId - The team for which the AI settings are being retrieved.
 */
function getAiTeamSettings(teams, targetTeamShortName) {
  var targetTeam;
  if (!teams) return undefined;
  if (!targetTeamShortName) {
    const _team = teams.find(team => team.aiSettings?.isEnabled);
    if (_team) {
      targetTeam = _team;
    }
  } else {
    targetTeam = teams.find(team => targetTeamShortName === team.teamShortName);
  }
  if (targetTeam) {
    // Check if the team has AI settings and return the relevant settings
    // along with the team ID to be used in the AI bot name and AI logo

    const { aiSettings, _id } = targetTeam;
    return {
      ...aiSettings,
      teamId: _id,
      teamShortName: targetTeamShortName,
      teamName: targetTeam.teamName
    };
  } else return undefined;
}

export { getAiTeamSettings };
